import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, $focused }) => css`
    align-items: center;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    z-index: ${(theme.v2.layers.important + 1)};
    min-width: ${$focused ? '720px' : 'unset'};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: unset;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0px 8px;
      position: static;
    }
  `}
`;

export const InputBorder = styled.div`
  ${({ theme, $moreThanOneLine, $focused }) => css`
      background: ${theme.v2.colors.gradient.twilight};
      padding: 1px;
      border-radius: ${$moreThanOneLine ? '16px' : '2000px'};
      width: ${$focused ? '100%' : 'unset'};
      transition: width 0.2s ease-in-out;
    `}
`;

export const InputWrapper = styled.div`
  ${({ theme, $moreThanOneLine }) => css`
    align-items: ${$moreThanOneLine ? 'flex-start' : 'center'};
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: inherit;
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: flex-start;
    padding: 10px 12px;
    flex-wrap: ${$moreThanOneLine ? 'wrap' : 'nowrap'};
  `}
`;

export const Image = styled.img`
  ${({ theme }) => css`
    border-radius: 50%;
    height: 24px;
    width: 24px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
  `}

`;

export const Input = styled.textarea`
  ${({ theme }) => css`
    background: transparent;
    border: none;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    outline: none;
    text-overflow: ellipsis;
    width: 100%;
    outline: none;
    height: 24px;
    overflow: hidden;
    resize: none;
    max-height: 200px;

    placeholder: {
      color: ${theme.v2.colors.neutral.lowMedium};
    }
  `}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  margin: 0px 0px 0px auto;
`;

export const ActionsButton = styled.button`
  ${({ theme, $focused, $disabled }) => css`
    align-items: center;
    background: transparent;
    border: none;
    color: ${$focused ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    gap: 8px;
    justify-content: center;
    margin: 0px;

    ${$disabled && css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
  `}
`;

export const SubmitWrapper = styled.div`
  display: flex;

  button {
    border-radius: 100%;
    height: 32px;
    padding: 0px;
    width: 32px;
  }

  div {
    align-items: center;
    height: unset;
    padding: 0px;
  }
`;


const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`;

export const Overlay = styled.div`
  ${({ theme, $clipPathStyle, $zIndex }) => css`
    animation: ${appear} 250ms forwards;
    backdrop-filter: blur(2px);
    background: ${theme.v2.colors.aiChat.overlay};
    height: 100vh;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: ${$zIndex !== undefined ? $zIndex : theme.v2.layers.awaysOnTop};

    ${$clipPathStyle && css`
      ${$clipPathStyle};
    `}
  `}
`;


export const OptionsWrapper = styled.ul`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: center;
    list-style: none;
    margin: 16px 0px 0px;
    max-width: 835px;
    padding: 0px;
    flex-wrap: wrap;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      align-items: flex-end;
      width: 100%;
    }
  `}
`;

export const Option = styled.li`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 12px;
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: center;
    letter-spacing: -0.176px;
    padding: 12px 16px;
    transition: background-color 0.2s ease-in-out;
    width: fit-content;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    }
  `}
`;

export const CloseButtonWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 32px;
    top: 20px;
    z-index: ${theme.v2.layers.important + 1};

    button {
      border-radius: 100%;
      height: 40px;
      padding: 0px;
      width: 40px;
      svg {
        width: 20px;
        height: 20px;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      right: 8px;
      top: 20px;
    }
  `}
`;
